import React from 'react';
import { Row, Col } from 'react-bootstrap';

import spotify from "../assets/logo/spotify.png"
import deezer from "../assets/logo/deezer-logo-coeur.png"
import apple from "../assets/logo/apple.png"
import amazon from "../assets/logo/amazon_music.png"
import youtube from "../assets/logo/ytb.png"

export const Musique = () => {

  const iframeCode = `
    <iframe style="border-radius: 12px" src="https://open.spotify.com/embed/album/1bg8wF55EwOnhAlyPJuNVe?utm_source=generator" width="100%" height="500" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
  `;

  return (
    <div className=' min-height'>


      <div className='music-all-container'>
        <div className='music-info-container'>

          <Row className='align-items-center'>
            <Col xs={12} md={6}>
              <div className="d-flex flex-column justify-content-center">
                <h2 className=''>LUMIÈRE</h2>
                <p className='home-about-p start-music'>
                  Plongez dans l'univers de l'album LUMIÈRE et laissez-vous transporter à travers 15 titres apaisants. Chaque chanson est un <strong>voyage</strong> unique, profondément <strong>émotionnel</strong>.
                </p>
                <p className='home-about-p'>
                  Avec ses mélodies enveloppantes, ses paroles <strong>poétiques</strong> et ses <strong>arrangements musicaux ciselés</strong> et magistraux, LUMIÈRE vous plonge dans une gamme d’émotions, alliant <strong>profondeur</strong> et <strong>légèreté</strong>, mélancolie et joie.
                </p>
                <p className='home-about-p'>
                  Cet album est le fruit d’une passion d’écrire, combinée à une <strong>composition</strong> musicale <strong>libre et généreuse</strong>.
                </p>
                <p className='home-about-p'>
                  Chaque titre est <strong>une histoire en soi</strong>, racontée par des sonorités et des <strong>mots à méditer</strong> qui touchent intimement.
                </p>
              </div>
            </Col>
            <Col xs={12} md={6}>
              <div dangerouslySetInnerHTML={{ __html: iframeCode }} />
            </Col>
          </Row>
        </div>
        <h3 className='text-center music-titre'>Disponible sur toutes les plateformes musicales</h3>
        <div className="music-container">
          <Row className="justify-content-center">
            <Col xs={4} md={2} className="center-content-musique"> <a href='https://open.spotify.com/intl-fr/album/0pQ2xFwiX6DIn1ZHHMprO9?si=dgpEj_VISI65NChoNMRWWA' target="_blank"><img src={spotify} className="logo-icon" /></a> </Col>
            <Col xs={4} md={2} className="center-content-musique"> <a href='https://www.deezer.com/fr/album/258947952' target="_blank"> <img src={deezer} className="logo-icon" /></a> </Col>
            <Col xs={4} md={2} className="center-content-musique"> <a href='http://itunes.apple.com/album/id1744168659?ls=1&app=itunes' target="_blank"> <img src={apple} className="logo-icon" /> </a></Col>
            <Col xs={4} md={2} className="center-content-musique"> <a href='https://music.amazon.com/albums/B0D33PMYCQ?marketplaceId=A13V1IB3VIYZZH&musicTerritory=FR&ref=dm_sh_snheD3ydO0tssVpCV5hqW697g' target="_blank"><img src={amazon} className="logo-icon amazon-logo" /> </a></Col>
            <Col xs={4} md={2} className="center-content-musique"> <a href='https://www.youtube.com/watch?v=BVahOzJxzq0&list=OLAK5uy_nAdD4QCYR0TSgsiVeFNeYwo_ePDCbbhSM' target="_blank"><img src={youtube} className="logo-icon" /></a> </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}

